import {ApiModel} from './api-model';

export class Tab extends ApiModel {

  title: string;
  link: string;
  componentNames: string[];
  visibility: boolean;
  currentTab: boolean;

}



// WEBPACK FOOTER //
// ./src/app/models/tab.ts